module.exports = __webpack_public_path__ + "static/media/edit.1a225ddf.svg";